export default __webpack_public_path__ + "static/media/turkey@2x.b728fb90.jpg";